import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';
import React from 'react';

const ToolTipComponent = ({ trigger, content }: IToolTipComponent) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="underline cursor-pointer">{trigger}</div>
      </TooltipTrigger>
      <TooltipContent>{content}</TooltipContent>
    </Tooltip>
  );
};

interface IToolTipComponent {
  trigger: React.ReactNode;
  content: React.ReactNode;
}

export default ToolTipComponent;
